import { Badge } from "antd";
import { getNotesAndBadge } from "../../domain/notes.domain";
import styles from "./badge.module.scss";

type Props = {
  note_type?: number | null | undefined;
  internal?: boolean;
  note_type_info?: {
    id: number;
    name: string;
  };
};

export default function NoteTypeBadge({ internal = false, note_type, note_type_info }: Props) {
  const componentName = "badge";
  if (note_type_info?.name) {
    const { badgeStyle } = getNotesAndBadge(note_type_info.id > 13 ? 0 : note_type_info.id);
    return (
      <Badge
        count={note_type_info.name}
        showZero
        className={`${styles[`${componentName}__badgestyle`]} ${badgeStyle} ${internal ? styles.internal : ""}`}
      />
    );
  }

  if (note_type !== null && note_type !== undefined) {
    const { name, badgeStyle } = getNotesAndBadge(note_type);
    return (
      <Badge
        count={name}
        showZero
        className={`${styles[`${componentName}__badgestyle`]} ${badgeStyle}  ${internal ? styles.internal : ""}`}
      />
    );
  }
  return null;
}
